import { isAxiosError } from "axios";
import filter from "lodash/filter";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { ApiValidationError, AxiosApiError, UnknownError } from "PFTypes";

export const isServerErrorResponse = (error: UnknownError): error is AxiosApiError =>
  isAxiosError(error) && (error.response?.status || 0) >= 500;

export const isUnauthorisedErrorResponse = (error: UnknownError): error is AxiosApiError =>
  isAxiosError(error) && error.response?.status === 401;

export const isValidationErrorResponse = (error: UnknownError): error is AxiosApiError<ApiValidationError> =>
  isAxiosError<{ errors: ApiValidationError }>(error) &&
  error.response?.status === 422 &&
  isArray(error.response?.data.errors);

export const isApiValidationError = (error: UnknownError): error is ApiValidationError =>
  !isNil(error?.status) && (!isNil(error?.source?.pointer) || !isEmpty(error.title));

export const parseValidationErrors = (unknownError: UnknownError): ApiValidationError[] | undefined => {
  // looking for errors under various paths to ensure backward compatibility
  const errors =
    unknownError?.response?.data?.errors ||
    unknownError?.data?.errors ||
    unknownError?.response?.errors ||
    unknownError?.errors ||
    unknownError;

  if (isArray(errors)) {
    return filter(errors, isApiValidationError);
  }

  if (isApiValidationError(errors)) {
    return [errors];
  }
};
